// extracted by mini-css-extract-plugin
export default {"container":"rF-z","innerContainer":"sF-z","multipleLines":"tF-z","heading":"uF-z","content":"vF-z","linkColor":"wF-z"};